import {Button, type ButtonProps} from '@primer/react'
import type React from 'react'
import {useContext} from 'react'

import {MarkdownEditorContext} from './MarkdownEditorContext'

export const Actions = ({children}: {children?: React.ReactNode}) => <>{children}</>
Actions.displayName = 'MarkdownEditor.Actions'

type ActionButtonProps = ButtonProps & {ref?: React.Ref<HTMLButtonElement>}

export const ActionButton = ({ref, ...props}: ActionButtonProps) => {
  const {disabled} = useContext(MarkdownEditorContext)
  return <Button disabled={disabled} {...props} ref={ref} />
}
ActionButton.displayName = 'MarkdownEditor.ActionButton'
